import { Controller } from "@hotwired/stimulus";

// Prints the page; the print stylesheet leaves out the menu and the buttons.
export default class extends Controller {
  print() {
    window.print();
  }
}
